module.exports = __webpack_public_path__ + "img/WalletCard.2cc6eb05.svg";